<template>
  <div id="search-wacana">
    <button class="btn btn-white" type="button" v-on:click="makeNew()">Buat Baru</button>
    <button class="btn btn-white" type="button" v-on:click="showModal = true">Pilih</button>
    <button class="btn btn-success" type="button" v-if="wacana != ''" v-on:click="editWacana">Edit</button>
    <button class="btn btn-danger" type="button" v-if="wacana != ''" v-on:click="showConfirmation = true">
      Reset
    </button>
    <br /><br />
    <blockquote v-if="wacana.id != 0">
      <p v-html="previewWacana"></p>
    </blockquote>
    <app-modal v-if="showModal" v-on:ok="showModal = false" :withCancel="true" v-on:cancel="cancel()">
      <h4 slot="header">Cari Wacana</h4>
      <div slot="body">
        <app-datatable :headers="headers" :items="wacanas" v-on:selected="wacana = $event.data[0]" :numbered="false"></app-datatable>
      </div>
    </app-modal>
    <app-modal v-if="showConfirmation" v-on:ok="resetWacana">
      <h4 slot="header">Perhatian</h4>
      <div slot="body">
        <p>Apakah anda yakin ingin melepas wacana ini dari soal?</p>
      </div>
    </app-modal>
    <app-modal v-if="showCreateWacanaModal" v-on:ok="saveWacana">
      <h4 slot="header">Buat Wacana Baru</h4>
      <div slot="body" >
        <app-editor :rows="8" v-on:content-updated="wacana = $event" :value="wacana"></app-editor>
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="saveWacana()">Simpan</button>
        <button type="button" class="btn btn-danger" @click="showCreateWacanaModal = false">Batal</button>
      </div>
    </app-modal>
  </div>
</template>

<script>
import Modal from '@/components/plugins/Modal'
import DataTable from '@/components/plugins/DataTable'
import MarkdownEditor from '@/components/plugins/MarkdownEditor'
import itembankService from '@/services/itembank.js'
import Marked from 'marked'
import Moment from 'moment'

export default {
  name: 'wacana',
  components: {
    'app-modal': Modal,
    'app-datatable': DataTable,
    'app-editor': MarkdownEditor,
  },
  props: ['value'],
  data: function() {
    return {
      showModal: false,
      showConfirmation: false,
      showCreateWacanaModal: false,
      headers: ['Konten', 'Created At'],
      wacanas: [],
      wacana: '',
      oldWacana: {},
      editing: false
    }
  },
  computed: {
    previewWacana: function() {
      if(this.wacana.content){
        return Marked(this.wacana.content)
      } else {
        return Marked(this.wacana)
      }
    }
  },
  methods: {
    resetWacana: function() {
      this.wacana = ''
      this.showConfirmation = false
    },
    saveWacana: function() {
      this.showCreateWacanaModal = false
      if(this.editing) {
        this.showCreateWacanaModal = false
        this.editing = false
      } else {
        this.showCreateWacanaModal = false
        this.editing = false
        var postData = {
          mapelId: this.$route.query.mapel,
          wacana: this.wacana
        }
        itembankService.createWacana(postData, function(result){
          if(result.success) {
            context.wacana = result.data.isi
            context.loadData()
          }
        })
      }
      
      // var context = this
      // if(!this.oldWacana.id) {
        
      // } else {
      //   itembankService.updateWacana(this.oldWacana.id, postData, function(result) {
      //     if(result.success) {
      //       context.loadData()
      //     }
      //   })
      // }
    },
    makeNew: function() {
      this.showCreateWacanaModal = true
    },
    editWacana: function() {
      this.showCreateWacanaModal = true
      this.editing = true
    },
    loadData: function() {
      var context = this
      var mapelId = this.$route.query.mapel
      itembankService.getListWacana(mapelId, function(result) {
        if(result.success) {
          context.wacanas = []
          result.data.forEach(function(wacana) {
            var createdAt = Moment(wacana.created_at).fromNow()
            context.wacanas.push({id: wacana.id, data: [wacana.isi, createdAt]})
          })
        }
      })
    },
    cancel: function() {
      this.wacana = ''
      this.showModal = false
    }
  },
  watch: {
    'wacana': function(val) {
      this.$emit('selected', val)
    },
    'value': function(val) {
      this.wacana = val
      this.oldWacana = val
    },
  },
  mounted: function() {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// FreeWacana.vue?52c6c1c3